import {FormikErrors} from 'formik';
import {recommendFieldsType} from '../CreateRecommend/recommendFields';

export const protectionPlanValidator = (
  values: recommendFieldsType,
  errors: FormikErrors<recommendFieldsType>
): FormikErrors<recommendFieldsType> => {
  if (!values.goal?.id) {
    if (!values.isSppDa) {
      errors.goal = 'Please select a goal';
    }
  }
  const protectionPlanValues = values.protectionPlan;
  if (!protectionPlanValues) {
    errors.protectionPlan = 'Fill in fields';
    return errors;
  }

  return errors;
};
